import { ContainerModule, type ContainerModuleLoadOptions } from 'inversify';
import { NetworkDependencyTypes } from '@shared/common/network/network.dependency-types';
import { JwtRepository } from '@shared/common/network/data/repository/jwt.repository';
import { JwtLocalStorageService } from '@shared/common/network/data/service/jwt-local-storage.service';
import { JwtService } from '@shared/common/network/domain/service/jwt.service';
import type { JwtRefreshService } from '@shared/common/network/domain/service/jwt-refresh.service';
import { DefaultJwtRefreshService } from '@shared/common/network/data/service/default-jwt-refresh.service';
import { CockpitApiListService } from '@shared/common/network/data/service/cockpit-api-list.service';
import { PublicCockpitApiService } from '@shared/common/network/data/service/public-cockpit.api-service';
import { AuthenticationRequiredService } from '@shared/common/network/domain/service/authentication-required.service';
import { JwtLocalStorageKey } from '@shared/common/network/domain/constant/jwt-local-storage-key.constant';

export const networkContainerModule = new ContainerModule((options: ContainerModuleLoadOptions) => {
  if (!options.isBound(NetworkDependencyTypes.JwtLocalStorageKey)) {
    options.bind<string>(NetworkDependencyTypes.JwtLocalStorageKey).toConstantValue(JwtLocalStorageKey.Default);
  }

  options
    .bind<JwtLocalStorageService>(NetworkDependencyTypes.JwtLocalStorageService)
    .to(JwtLocalStorageService)
    .inSingletonScope();
  options.bind<JwtRepository>(NetworkDependencyTypes.JwtRepository).to(JwtRepository).inSingletonScope();
  options.bind<JwtService>(NetworkDependencyTypes.JwtService).to(JwtService).inSingletonScope();
  options
    .bind<JwtRefreshService>(NetworkDependencyTypes.JwtRefreshService)
    .to(DefaultJwtRefreshService)
    .inSingletonScope();
  options
    .bind<CockpitApiListService>(NetworkDependencyTypes.CockpitApiListApiService)
    .to(CockpitApiListService)
    .inSingletonScope();
  options
    .bind<PublicCockpitApiService>(NetworkDependencyTypes.PublicCockpitApiService)
    .to(PublicCockpitApiService)
    .inSingletonScope();
  options
    .bind<AuthenticationRequiredService>(NetworkDependencyTypes.AuthenticationRequiredService)
    .to(AuthenticationRequiredService)
    .inSingletonScope();
});
